import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as supplierActions from '../_actions/supplier';
import { Supplier } from '../_models';

export interface SupplierState extends EntityState<Supplier> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Supplier> = createEntityAdapter<Supplier>();

const initialState: SupplierState = adapter.getInitialState({
  loading: false,
  error: null,
});

const supplierReducer = createReducer(
  initialState,

  on(supplierActions.loadSuppliers, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(supplierActions.loadSuppliersSuccess, (state, { suppliers }) =>
    adapter.setAll(suppliers, { ...state, loading: false })
  ),

  on(supplierActions.loadSuppliersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(supplierActions.addSupplierSuccess, (state, { supplier }) => adapter.addOne(supplier, state)),

  on(supplierActions.updateSupplierSuccess, (state, { supplier }) =>
    adapter.upsertOne(supplier, state)
  ),

  on(supplierActions.deleteSupplierSuccess, (state, { id }) => adapter.removeOne(id, state)),

  on(
    supplierActions.addSupplierFailure,
    supplierActions.updateSupplierFailure,
    supplierActions.deleteSupplierFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: SupplierState | undefined, action: Action) {
  return supplierReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
